var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',{attrs:{"xs12":"","sm6":"","d-flex":""}},[_c('v-select',{attrs:{"items":_vm.validStatus,"label":"Status","item-text":"title","item-value":"business","return-object":"","prepend-icon":"label"},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }